import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  TPrototypeAccessConfigDto,
  useAvApi,
} from '@app-velocity/av-api-v2';

export const useConfigurePrototypeAccessMutation = (
  prototypeId: string,
  type: 'report' | 'testing'
) => {
  const { prototypePasswordManagement } = useAvApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (dto: TPrototypeAccessConfigDto) => {
      const { data } =
        await prototypePasswordManagement.putV2PrototypesPasswordAccessByPrototypeIdAndType(
          dto,
          {
            prototypeId,
            type,
          }
        );

      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['prototype-access-config', prototypeId, type],
      });
      queryClient.invalidateQueries({
        queryKey:
          type === 'report'
            ? ['prototype-report-password', prototypeId]
            : ['prototype-human-testing-password', prototypeId],
      });
    },
  });
};
